import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';
import { ColumnValueDistribution } from './useColumnValueDistribution';

interface MultiDistroField {
  pipelineNodeId: string;
  fieldId: string;
}

interface ColumnValueDistributionResponse {
  records: ColumnValueDistribution[];
}

export function useMultiColumnDistribution(
  fields: MultiDistroField[],
  enabled: boolean = true
) {
  // Sort fields for stable cache key
  const sortedFields = [...fields].sort((a, b) =>
    `${a.pipelineNodeId}:${a.fieldId}`.localeCompare(`${b.pipelineNodeId}:${b.fieldId}`)
  );

  return useQuery<ColumnValueDistribution[]>({
    queryKey: ['multi-column-distribution', sortedFields],
    queryFn: async () => {
      if (fields.length === 0) return [];

      const result = await ApiService.getInstance().request(
        'POST',
        '/pipelinenodes/multi-distro',
        {
          fields: fields.map((f) => ({
            pipeline_node_id: f.pipelineNodeId,
            field_id: f.fieldId,
          })),
        }
      ) as ColumnValueDistributionResponse;
      return result.records || [];
    },
    enabled: enabled && fields.length > 0,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
